.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}
